import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Shield } from 'lucide-react';

export const HAEVNSummary = ({ summary, profileLabel }) => {
  if (!summary) return null;

  return (
    <Card className="border-border bg-card" data-testid="haevn-summary">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Shield className="w-4 h-4 text-primary" />
          <CardTitle className="text-xl font-light">Your HAEVN Profile Summary</CardTitle>
        </div>
        {profileLabel && (
          <p className="text-xs text-muted-foreground mt-1">{profileLabel}</p>
        )}
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Interpretive sections */}
        <div className="space-y-5">
          <div>
            <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
              What drives you
            </span>
            <p className="text-foreground leading-relaxed mt-1.5">
              {summary.whatDrivesYou}
            </p>
          </div>

          <div>
            <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
              What tends not to work
            </span>
            <p className="text-foreground leading-relaxed mt-1.5">
              {summary.whatDoesntWork}
            </p>
          </div>

          <div>
            <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
              What to look for
            </span>
            <p className="text-foreground leading-relaxed mt-1.5">
              {summary.whatToLookFor}
            </p>
          </div>
        </div>

        {/* Metadata row */}
        <div className="pt-4 border-t border-border/50 grid grid-cols-2 sm:grid-cols-3 gap-4">
          <div>
            <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">Structure</span>
            <p className="text-sm text-foreground mt-0.5">{summary.structureType}</p>
          </div>
          <div>
            <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">Sensitivity</span>
            <p className="text-sm text-foreground mt-0.5">{summary.contextSensitivity}</p>
          </div>
          <div>
            <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">Readiness</span>
            <p className="text-sm text-foreground mt-0.5">{summary.readiness}</p>
          </div>
        </div>

        {/* Anchor statement */}
        <p className="text-xs text-muted-foreground italic pt-2">
          This reflects the kind of experience that tends to work for you, not just what you say you want.
        </p>
      </CardContent>
    </Card>
  );
};
